export { default } from 'raven-js';



// WEBPACK FOOTER //
// ./src/@utils/sentry.web.js